import React, { useState, useEffect } from "react";
import { Outlet, useLocation, NavLink, useNavigate } from "react-router-dom";
import { AiOutlineUser } from 'react-icons/ai';
import { IoIosArrowForward } from 'react-icons/io';
import { instance } from "./axios";
import { useStore } from "./state.js";
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { TabContent } from "react-bootstrap";
import zustand from "zustand";
import { Logout } from "./helper";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoArrowBack } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";


const Layout = () => {
  let location1 = useLocation()
let navigate = useNavigate();
  const zstate = useStore((state) => state.groups);
  const setZState = useStore((state) => state.setGroups);
  const setMState = useStore((state) => state.setMachines);
  const setSettingState = useStore((state) => state.setSettings);
  const userModal = useModal('addphonebook');
  const setSender = useStore((state) => state.setSenderid);
  const [state, setState] = useState({});
  const [menu, setMenu] = useState(0);
  const [title, setTitle] = useState(null);
  const [is_search, setSearch] = useState(false);
  const [search_visible, showSearch] = useState(false);


  const showModal = (row) => {
    userModal.show({ data: row }).then((res) => {
      fetchData();
    });


  }


  const fetchData = () => {
    instance
      .get("/site_home.php")
      .then(function (response) {
        setState(response.data)
        setZState(response.data.groups)
        setMState(response.data.machines)
        setSettingState(response.data)
        setSender(response.data.senderid)
      })
      .catch(function (error) { })
      .then(function () { });
  }

  const { auth, setAuth } = useStore((state) => state);
  let activeStyle = {
    textDecoration: "underline",
  };
  useEffect(() => {
    fetchData()

  }, []);
  useEffect(() => {
    setSearch(location1.pathname == "/listings" ? 1 : 0)
    if (menu == 1) {
      setMenu(0)
    }
    //
  }, [location1]);
  const location = useLocation();

  const getNavLinkClass = path => {
    return path.includes(location.pathname)
      ? " show"
      : "";
  };

  const showhideMenu = (e) => {
    if (menu == 1) {
      setMenu(0);
    } else {
      setMenu(1);
    }
  }
  return (
    <>
      <header className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap py-0 shadow-sm px-3">
        {title && <span style={{cursor:'pointer',color:'#fff', width:'47px'}} className="d-flex align-items-center" onClick={()=>navigate(-1)}><IoArrowBack style={{fontSize:'20px'}}/> <small className="ms-1">Back</small></span>}
        <a className="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6" onClick={()=>navigate("/")}>
          {title ? title : 'GraniteMandi.com'}
        </a>
{is_search == 1 ? <div className={` ${search_visible ? 'bg-light text-dark' : 'text-white'}`} style={{fontSize:'18px', padding:'10px', pointerEvents:'click'}} onClick={()=>showSearch(search_visible ? false : true)}>
<FaSearch/>
</div>

:
        <div className="d-md-none ">
          <input type="checkbox" className="btn-check" id="btn-check-outlined" defaultValue={menu} onChange={(e) => showhideMenu(e)} />
          <label className="btn btn-default fs-1" for="btn-check-outlined"><GiHamburgerMenu style={{ color: '#fff' }} /></label>

        </div>
}
      </header>

      <div className="container-fluid">
        <div className="row">
          <nav
            id="sidebarMenu"
            className={`d-md-none bg-light sidebar ${menu == '1' ? 'd-block' : 'd-none'}`}
          >
            <div className="position-sticky pt-3 sidebar-sticky">
            
            </div>
          </nav>

          <main className="col-12 ms-sm-auto px-md-4">
            <section className="content d-inline-block w-100">
              <div className="container-fluid">
                <Outlet context={{ setTitle, search_visible }}/>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default Layout;
